module.exports = __webpack_public_path__ + "img/image22.3adc72bc.png";